import { AttributeStatusTypes } from "@enums/attribute-status-types";
import { OOBStatusTypes } from "@enums/oob-status-types";
import { AttributeFormState } from "../types/state/attribute-form-state";

export const checkIsOOBComplete = (attributeFormStates: Array<AttributeFormState>) => {
    let isComplete = true;
    if (attributeFormStates) {
        isComplete = attributeFormStates.every((attributeFormState) => {
            if (
                attributeFormState.oobStatus === OOBStatusTypes.INCOMPLETE &&
                attributeFormState.status === AttributeStatusTypes.NEW
            ) {
                return false;
            }
            return true;
        });
    }

    return isComplete;
};

export const checkIsAsyncComplete = (attributeFormStates: Array<AttributeFormState>, shouldGoToDcui: boolean, isDcuiProcessCompleted: boolean) => {
    let isComplete = true;
    if (attributeFormStates) {
        const attributeStatusesCompleted = attributeFormStates.every((attribute) => {
            if (attribute.status === AttributeStatusTypes.ASYNC_INCOMPLETE) {
                return false;
            }
            return true;
        });

        isComplete = shouldGoToDcui ? attributeStatusesCompleted && isDcuiProcessCompleted : attributeStatusesCompleted;
    } else if (shouldGoToDcui) {
        return isDcuiProcessCompleted;
    }

    return isComplete;
};

export const hasEmail = (attributeFormStates: Array<AttributeFormState>) => {
    const emailAttribute = attributeFormStates.find((attribute) => attribute.type === 'Email');
    return !!emailAttribute;
};